// client/src/routes/app/settings/security.tsx — SCR-SET-002 „Securitate & MFA" · AUTH-004.

import { createFileRoute } from '@tanstack/react-router';

import { SecurityScreen } from '@/features/settings/SecurityScreen';

export const Route = createFileRoute('/app/settings/security')({
  component: SecurityScreen,
});
